import React from 'react';
import { List } from 'immutable';
import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import Truncate from 'react-truncate';

import { WysiwygField } from '../../../../components';
import Teaser from '../../../../components/Teaser';

import './style.scss';

const NodeVacancyTeaser = ({ entity, className, context }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const summary = entity.getIn(['body', 0, 'summary'], null);
  const body = entity.getIn(['body', 0, 'processed']);
  const langcode = entity.getIn(['langcode', 0, 'value']);
  const url = entity.getIn(['paths', langcode]);
  const locations = entity.getIn(['field_location'], List());
  const type = entity.getIn(['field_vacancy_type', 0, 'entity', 'name', 0, 'value'], null);

  if (context && context === 'related_content') {
    return (
      <div className="BaseTeaser NodeArticleTeaser">
        <Teaser entity={entity} large={false} labeled type="vacancy" />
      </div>
    );
  }

  return (
    <div className="NodeVacancyTeaser">
      <div className="NodeVacancyTeaser__top">
        {type && (
          <div className="Badge Badge--primary">
            {type}
          </div>
        )}
        {locations.size > 0 && (
          <div className="NodeVacancyTeaser__top__location">
            {locations.size > 1 ? (
              <span>Meerdere locaties</span>
            ) : (
              <span>{entity.getIn(['field_location', 0, 'entity', 'title', 0, 'value'])}</span>
            )}
          </div>
        )}
      </div>

      <CoreLink to={url} className="Teaser__link">
        <h3 className="NodeVacancyTeaser__title">{title} <div className="icon icon-arrow-right icon-variant-0" /></h3>
      </CoreLink>
      <div className="NodeVacancyTeaser__body">
        <Truncate lines={4} ellipsis="...">
          <WysiwygField
            property="schema:text"
            html={!summary ? body : summary} />
        </Truncate>
      </div>
    </div>
  );
};

export default NodeVacancyTeaser;
